import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import {
  userStore,
  usersStore,
} from "@sourcewhale/shared/src/svelte/api-stores/user-store";
import { derived, writable } from "svelte/store";
import { getTeam } from "../api/admin";
import { getAllIntegrations } from "../api/integrations";

export const adminsStore = derived(usersStore, ($usersStore) =>
  $usersStore ? $usersStore.filter((user) => user.isAdmin) : [],
);

export const notetakerRequestedStore = derived(
  [userStore, adminsStore],
  ([$userStore, $adminsStore]) =>
    $userStore?.notetakerRequested ||
    $adminsStore.some((admin) => admin.notetakerRequested),
);

export const showOnboardingModal = writable(false);

export const showFullOnboardingModal = derived(
  [userStore, adminsStore],
  ([$userStore, $adminsStore]) =>
    !$userStore?.isPlgTrial &&
    $userStore?.isAdmin &&
    $adminsStore?.every(
      (admin) => admin.notetakerOnboardingProgress !== "completed",
    ),
);

export const isPlgTrial = derived(
  [userStore],
  ([$userStore]) => $userStore.isPlgTrial,
);

export const showOnboardingAsReview = derived(
  userStore,
  ($userStore) => $userStore?.showNotetakerOnboardingAsReview,
);

export const teamStore = SwApiStore({
  get: (...args) => getTeam({}, ...args),
});

export const teamNotetakerSettingsStore = derived(
  teamStore,
  ($teamStore) => $teamStore.notetakerSettings,
);

export const integrationsStore = SwApiStore({
  get: () => getAllIntegrations({ excludeOverrides: true }),
});
